import { render, staticRenderFns } from "./inventaire.vue?vue&type=template&id=f9cd9d30&scoped=true"
import script from "./inventaire.vue?vue&type=script&lang=js"
export * from "./inventaire.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9cd9d30",
  null
  
)

export default component.exports